export function getBookmarkGroups(state) {
  return state.bookmarkGroups;
}

export function getBookmarkPage(state) {
  return state.bookmarkPage;
}
